﻿"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
const app_commons_1 = require("@its-suite/app-commons");
const actions_1 = require("./actions");
__export(require("./actions"));
const INITIAL_STATE = null;
exports.reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actions_1.SessionActionTypes.SET_SESSION:
            return action.payload;
        case actions_1.SessionActionTypes.AFTER_LOGOUT:
            return state;
        default:
            app_commons_1.exhaustiveCheck(action);
    }
    return state;
};
//# sourceMappingURL=index.js.map